export const orderViewMixin = {
    computed: {

    },

    methods: {

    }
}